import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=421511ac&scoped=true&"
import script from "./alerts.vue?vue&type=script&lang=js&"
export * from "./alerts.vue?vue&type=script&lang=js&"
import style0 from "./alerts.vue?vue&type=style&index=0&id=421511ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421511ac",
  null
  
)

export default component.exports